export default {
    modalShowImageVariations: {
        imageAi: 'Bild AI',
        regenerateImage: 'Generera nytt innehåll',
        description: 'Beskrivning',
        style: 'Stil',
        saveToLibrary: 'Spara till biblioteket',
        continue: 'Fortsätt',
        cancel: 'Avbryt',
        select: 'Välj',
        copy: 'Kopia',
        selectedImage: 'Utvald bild',
        saved: 'Sparad',
        variations: 'Variationer',
    },
};
